<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Multiple Beds</h5>
        <button type="button" class="close" @click="$emit('close')">
          &times;
        </button>
      </div>

      <div class="modal-body">
        <div class="table-header">
          <span>#</span>
          <span>Bed Number</span>
          <span>Ward</span>
          <span>Charge Class</span>
          <span>Bed Type</span>
          <span></span>
        </div>

        <div class="table-row" v-for="(bed, index) in beds" :key="index">
          <span>{{ index + 1 }}</span>
          <input type="text" v-model="bed.bed_number" />

          <select v-model="bed.ward_id">
            <option disabled value="">-- Ward --</option>
            <option v-for="ward in wards" :key="ward.id" :value="ward.id">
              {{ ward.ward_name }}
            </option>
          </select>

          <select v-model="bed.bed_charge_class">
            <option disabled value="">-- Class --</option>
            <option v-for="clas in classes" :key="clas.id" :value="clas.id">
              {{ clas.name }}
            </option>
          </select>

          <input type="text" v-model="bed.bed_type" />

          <button class="btn-remove" @click="removeRow(index)">×</button>
        </div>

        <button class="btn-add" @click="addRow">+ Add Bed</button>
      </div>

      <div class="modal-footer">
        <button class="btn-save" @click="saveBeds">Save All</button>
        <button class="btn-cancel" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import showNotification from "../../../notification/notify";
export default {
  name: "AddMultipleBedsModal",
  //   props: {
  //     wards: Array,
  //   },
  data() {
    return {
      wards: [],
      classes: [],
      beds: [
        {
          bed_number: "",
          ward_id: "",
          bed_charge_class: "",
          bed_type: "",
        },
      ],
    };
  },
  methods: {
    closeMod() {
      this.$emit("close");
    },
    async getPopulation() {
      const url = "inpatient/getCompanyWards";
      const data = await generalApiRequest(url, "GET", {}, 1);
      console.log(data);

      this.wards = data;

      const class_url = "inpatient/getCompanyBedChargeClasses";
      const class_body = {};
      const rs = await generalApiRequest(class_url, "GET", class_body, 1);
      console.log(rs.data);

      this.classes = rs.data;
    },
    addRow() {
      this.beds.push({
        bed_number: "",
        ward_id: "",
        bed_charge_class: "",
        bed_type: "",
      });
    },
    removeRow(index) {
      this.beds.splice(index, 1);
    },
    async saveBeds() {
      const invalid = this.beds.some(
        (bed) => !bed.bed_number || !bed.ward_id || !bed.bed_charge_class
      );
      if (invalid) {
        alert("Please fill Bed Number, Ward, and Charge Class for all beds.");
        return;
      }
      //
      const class_url = "inpatient/createBed";
      const class_body = { beds: this.beds };
      console.log(class_body);

      try {
        await generalApiRequest(class_url, "POST", class_body, 1);
        this.closeMod();
        showNotification("Successfully added bed(s)", "success");
      } catch (error) {
        showNotification("Unable to add bed(s)", "error");
      }

      //
    },
  },
  mounted() {
    this.getPopulation();
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(10, 10, 10, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  padding: 1rem;
  border-radius: 0.4rem;
  width: 90%;
  max-width: 90vw;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
}

.modal-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.close {
  background: #e31919;
  color: #fff;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
  border-radius: 50%;
  width: 28px;
  height: 28px;
}

.modal-body {
  margin-bottom: 1rem;
}

.table-header,
.table-row {
  display: grid;
  grid-template-columns: 30px 1fr 1fr 1fr 1fr 40px;
  gap: 0.5rem;
  align-items: center;
  padding: 0.4rem 0;
}

.table-header {
  font-weight: 600;
  border-bottom: 1px solid #ddd;
  margin-bottom: 0.5rem;
}

.table-row {
  border-bottom: 1px solid #f0f0f0;
}

input[type="text"],
select {
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 0.3rem;
  width: 100%;
}

.btn-remove {
  background: #e31919;
  color: #fff;
  border: none;
  padding: 0.35rem 0.7rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.1rem;
}

.btn-add {
  background: #2786f7;
  color: #fff;
  border: none;
  padding: 0.45rem 1rem;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 0.8rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 1rem;
}

.btn-save {
  background: #2786f7;
  color: #fff;
  border: none;
  padding: 0.5rem 1.2rem;
  border-radius: 0.3rem;
  cursor: pointer;
}

.btn-cancel {
  background: #777;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.3rem;
  cursor: pointer;
}
</style>
